<template>
  <div class="lead container">
    <div class="content">
      <h2 v-scroll-reveal="{ delay: 200 }">
        Made People is an artisan e-commerce agency driven by effect and value.
        It is adjusting to the expectations of individuals that provides us with
        creative, new and inspiring challenges.
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lead",
  props: {
    header: String
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";

.lead {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  //padding-top:10vh !important;
  .content {
    position: relative;
    z-index: 1;
    h2 {
      @include headline-small;
      font-weight: 400;
      width: 50%;
      padding-right: 3vw;
      b {
        font-weight: 600;
      }
    }
  }
}
@media (max-width: $tablet) {
  .lead {
    .content {
      h2 {
        width: 100%;
      }
    }
  }
}
</style>
